import { categories } from '@/mocks/homeData';

export default function Footer() {
  const popularCategories = categories.slice(0, 7);

  return (
    <footer className="relative bg-foreground-900 rounded-t-3xl mx-3 md:mx-4 mt-8 overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none select-none">
        <span className="absolute bottom-0 left-0 right-0 text-[8rem] md:text-[12rem] font-heading font-bold text-foreground-800/20 whitespace-nowrap leading-none translate-y-1/4">
          ALLCHINABUY
        </span>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          {/* Column 1: Brand */}
          <div className="lg:col-span-1">
            <h3 className="font-heading text-xl md:text-2xl font-bold text-background-50 mb-4">
              Start Saving Time
            </h3>
            <p className="text-sm text-foreground-400 leading-relaxed">
              The <strong className="text-background-50/80">AllChinaBuy Spreadsheet</strong> is your go-to resource for organized product lists, QC photos, and trusted seller information. Updated weekly.
            </p>
            <p className="mt-4 text-xs text-foreground-500">
              &copy; {new Date().getFullYear()} AllChinaBuySpreadsheet.team
            </p>
          </div>

          {/* Column 2: Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Categories</h4>
            <ul className="space-y-2.5">
              {popularCategories.map((cat) => (
                <li key={cat.id}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-foreground-400 hover:text-accent-300 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Quick Links</h4>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-400 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  Main Store
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-400 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  AllChinaBuy Sheet
                </a>
              </li>
              <li>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-sm text-foreground-400 hover:text-accent-300 transition-colors cursor-pointer"
                >
                  Buy It Now
                </a>
              </li>
            </ul>
          </div>

          {/* Column 4: Newsletter */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">Stay Updated</h4>
            <p className="text-xs text-foreground-400 mb-4 leading-relaxed">
              Get notified when new categories and products are added to the spreadsheet.
            </p>
            <form
              data-readdy-form
              action="https://readdy.ai/api/form/d8uk70r9akq3s3asoa20"
              method="POST"
              encType="application/x-www-form-urlencoded"
              className="flex gap-2"
            >
              <input
                type="text"
                name="phone_alt"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                className="form-anti-spam"
              />
              <input
                type="email"
                name="email"
                placeholder="Your email"
                required
                className="flex-1 min-w-0 px-4 py-2.5 rounded-lg bg-foreground-800 border border-foreground-700 text-sm text-background-50 placeholder:text-foreground-500 focus:outline-none focus:border-accent-500 transition-colors"
              />
              <button
                type="submit"
                className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-500 text-background-50 hover:bg-accent-600 transition-colors flex-shrink-0 cursor-pointer"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </form>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-10 pt-6 border-t border-foreground-800/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            Reviewed by ACB Research Team &middot; Updated: June 2026
          </p>
          <p className="text-xs text-foreground-500">
            Editorial Guidelines: Our content is regularly reviewed and updated.
          </p>
        </div>
      </div>

      {/* Anti-spam form styles */}
      <style>{`
        .form-anti-spam {
          position: absolute;
          left: -9999px;
          opacity: 0;
          height: 0;
          width: 0;
          overflow: hidden;
          pointer-events: none;
        }
      `}</style>
    </footer>
  );
}